export default __webpack_public_path__ + "static/tile_mobile@2x-5c98c8eeb86cf1e74c6dd751b8917051.png";